import { render, staticRenderFns } from "./WeekBarGraph.vue?vue&type=template&id=36d7f622&scoped=true"
import script from "./WeekBarGraph.vue?vue&type=script&lang=js"
export * from "./WeekBarGraph.vue?vue&type=script&lang=js"
import style0 from "./WeekBarGraph.vue?vue&type=style&index=0&id=36d7f622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7f622",
  null
  
)

export default component.exports